import { donationsApi } from '../api/donationsApi'
import type { DonationCreateInput } from '../types/donation'

export const addDonation = async (donation: DonationCreateInput) => {
  try {
    const { data } = await donationsApi.createDonation(donation)
    return data
  } catch (error) {
    console.error(`Error creating donation: `, error)
    throw error
  }
}
